<template>
  <v-dialog width="500px" v-model="show" @click:outside="$store.commit('close_submission_editable_dialog')">
    <v-card>
      <v-card-title>
        قفل کردن اثر ارسالی
      </v-card-title>
      <v-card-text>
        آیا از تایید اطلاعات این اثر اطمینان دارید؟
        <br>
        این کاربر دیگر نمیتواند اطلاعات اثر خود را ویرایش کند.
      </v-card-text>
      <v-card-actions>
        <v-btn color="blue darken-1" text @click="$store.commit('close_submission_editable_dialog')">
          لغو
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text
               @click="api_call">
          تایید
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {mapState} from "vuex";

export default {
  name: "SubmissionEditableDialog",
  methods: {
    api_call() {
      this.$store.dispatch('update_submission_editable', {
        submission_id: this.submission.id,
        edit_enabled: !this.submission.edit_enabled
      }).then(() => {
        this.$store.commit('close_submission_editable_dialog');
      });
    },
  },
  computed: {
    ...mapState({
      show: state => state.Admin.settings.submission_editable_dialog.show,
      submission: state => state.Admin.settings.submission_editable_dialog.submission,
    }),
  }
}
</script>

<style scoped>

</style>